import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCamera, FaLayerGroup, FaSlidersH, FaCheckCircle } from 'react-icons/fa';
import AnimateOnScroll from './AnimateOnScroll';

const steps = [
  { icon: FaCamera, key: 'step1' },
  { icon: FaLayerGroup, key: 'step2' },
  { icon: FaSlidersH, key: 'step3' },
  { icon: FaCheckCircle, key: 'step4' },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="py-20" style={{ background: '#f8f9fe' }} id="how-it-works">
      <div className="container">
        <AnimateOnScroll>
          <div className="text-center mb-14">
            <p className="t-h1">{t('HowItWorks.label')}</p>
            <h2 className="t-h2 max-w-xl mx-auto">{t('HowItWorks.title')}</h2>
            <p className="t-p max-w-lg mx-auto">{t('HowItWorks.subtitle')}</p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <AnimateOnScroll key={i} animation="fadeUp" delay={i * 50}>
                <div className="relative flex flex-col items-center text-center">
                  {/* Step number badge */}
                  <div
                    className="w-14 h-14 rounded-full flex items-center justify-center text-white font-bold text-lg mb-4 relative z-10"
                    style={{ background: '#010C66', fontFamily: '"Wix Madefor Display", sans-serif' }}
                  >
                    {i + 1}
                  </div>

                  {/* Connector line */}
                  {i < steps.length - 1 && (
                    <div
                      className="hidden lg:block absolute top-7 left-[calc(50%+35px)] h-0.5"
                      style={{ width: 'calc(100% - 56px)', background: '#e0e7ff' }}
                    />
                  )}

                  <Icon size={20} style={{ color: '#709CFF' }} className="mb-3" />
                  <h3
                    className="font-bold mb-1 text-sm"
                    style={{ fontFamily: '"Wix Madefor Display", sans-serif', color: '#010C66' }}
                  >
                    {t(`HowItWorks.${step.key}.title`)}
                  </h3>
                  <p style={{ color: '#9ca3af', fontSize: '0.8rem', maxWidth: '190px' }}>
                    {t(`HowItWorks.${step.key}.description`)}
                  </p>
                </div>
              </AnimateOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
}
